import React, { useState } from 'react'
import { router, usePage } from '@inertiajs/react'
import {
  Box, Button, FormControl, InputLabel, Select, MenuItem, TextField, InputAdornment,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import StatusBadge from '../../../../components/ui/StatusBadge'

Index.layout = (page) => <AppShell>{page}</AppShell>

export default function Index({ property, resolutions, filters = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const [status, setStatus] = useState(filters.status || '')
  const [year, setYear] = useState(filters.year || '')
  const [q, setQ] = useState(filters.q || '')

  const applyFilters = () => {
    router.get(`/m/${tenant.slug}/properties/${property.id}/resolutions`, {
      status: status || undefined, year: year || undefined, q: q || undefined,
    }, { preserveState: true, replace: true })
  }

  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i)

  return (
    <Box>
      <PageHeader
        title="Beschlusssammlung"
        breadcrumbs={[
          { label: 'Beschlusssammlung' },
        ]}
      />

      <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
        <TextField size="small" placeholder="Suche nach Titel..."
          value={q} onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && applyFilters()}
          slotProps={{ input: { startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> } }}
          sx={{ minWidth: 220 }} />
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Status</InputLabel>
          <Select value={status} label="Status" onChange={(e) => setStatus(e.target.value)}>
            <MenuItem value="">Alle</MenuItem>
            <MenuItem value="accepted">Angenommen</MenuItem>
            <MenuItem value="rejected">Abgelehnt</MenuItem>
            <MenuItem value="final">Bestandskräftig</MenuItem>
            <MenuItem value="challenged">Angefochten</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 100 }}>
          <InputLabel>Jahr</InputLabel>
          <Select value={year} label="Jahr" onChange={(e) => setYear(e.target.value)}>
            <MenuItem value="">Alle</MenuItem>
            {years.map((y) => <MenuItem key={y} value={String(y)}>{y}</MenuItem>)}
          </Select>
        </FormControl>
        <Button variant="outlined" size="small" onClick={applyFilters}>Filtern</Button>
      </Box>

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Nr.</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Datum</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Titel</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Versammlung</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {resolutions.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Beschlüsse gefunden.</Typography>
                </TableCell>
              </TableRow>
            )}
            {resolutions.map((r) => (
              <TableRow key={r.id} hover sx={{ cursor: 'pointer' }}
                onClick={() => router.visit(`/m/${tenant.slug}/properties/${property.id}/resolutions/${r.id}`)}
                data-testid={`resolution-row-${r.id}`}>
                <TableCell><Typography variant="body2" fontWeight={500}>#{r.resolution_number}</Typography></TableCell>
                <TableCell>{r.date}</TableCell>
                <TableCell>{r.title}</TableCell>
                <TableCell>
                  {r.assembly_date && (
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                      <Typography variant="body2">{r.assembly_date}</Typography>
                      <StatusBadge type="assembly_type" value={r.assembly_type} size="small" />
                    </Box>
                  )}
                </TableCell>
                <TableCell><StatusBadge type="resolution_status" value={r.status} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
